export default __webpack_public_path__ + "static/media/hyperlink-page-icon.f67c6fec.svg";